import React, { useEffect, useState } from "react";
import SectionTitle from "../../Components/SectionTitle";
import { IBettingWebsiteLanguage } from "../../types/BettingWebsite.Language";
import { getLanguages } from "./action";
import { Image, Table, TableProps } from "antd";
type Props = {};

interface TableDataType {
  logo: string;
  en: string;
  ar: string;
  fr: string;
}

const columns: TableProps<TableDataType>["columns"] = [
  {
    title: "Flag",
    dataIndex: "logo",
    key: "logo",
    render: (text) => (
      <Image width={30} src={`https://flagcdn.com/${text.toLowerCase()}.svg`} />
    ),
  },
  {
    title: "English",
    dataIndex: "en",
    key: "en",
  },
  {
    title: "Arabic",
    dataIndex: "ar",
    key: "ar",
  },
  {
    title: "French",
    dataIndex: "fr",
    key: "fr",
  },
];

const Languages = (props: Props) => {
  const [data, setData] = useState<TableDataType[]>([]);

  const fetchData = async () => {
    const languages = await getLanguages();
    let table_languages: TableDataType[] = [];
    languages.map((lg) => {
      table_languages.push({
        logo: lg.Flag,
        en: lg.Country.En,
        ar: lg.Country.Ar,
        fr: lg.Country.Fr,
      });
    });
    setData(table_languages);
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div className="space-y-5">
      <SectionTitle title="Languages" />
      <Table<TableDataType> columns={columns} dataSource={data} />
    </div>
  );
};

export default Languages;
